var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-title",class:_vm.className},[_c('div',{staticClass:"normal-title__header"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }